import React from "react";
import { Modal, Spinner } from "react-bootstrap";

export function LoadingModal({ show = false, text = "Procesando..." }) {
  return (
    <Modal
      show={show}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="bg-transparent border-0 shadow-none"
    >
      <div className="d-flex flex-column align-items-center justify-content-center py-5">
        <Spinner animation="border" variant="light" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
        <p className="mt-3 text-white fw-semibold">{text}</p>
      </div>
    </Modal>
  );
}
